const ACTIVE_EXPERIMENTS_STRING_KEY = 'optimizeActiveExperiments';

// TODO: Think about a way to unify this storage functions (session, local, cookies, etc.)

export function getActiveExperiments(
  storage = sessionStorage,
  storageKey = ACTIVE_EXPERIMENTS_STRING_KEY,
) {
  const storedData = storage.getItem(storageKey);
  return storedData ? JSON.parse(storedData).experiments : [];
}

export function persistActiveExperiments(
  experiments,
  storage = sessionStorage,
  storageKey = ACTIVE_EXPERIMENTS_STRING_KEY,
) {
  storage.setItem(storageKey, JSON.stringify(experiments));
}
